import { useCallback } from 'react';

import { useAppDispatch } from '@/hooks/redux-hooks';
import { openExportDrawer } from '@/slices/drawerSlice';
import { setExport } from '@/slices/exportSlice';

const useOpenExportSelection = () => {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    dispatch(setExport({}));
    dispatch(openExportDrawer({ showHistory: false }));
  }, [dispatch]);
};

export default useOpenExportSelection;
